<template>
    <div class="roomName py-1 px-2">
        <div class="name">Room Name: {{roomName}} </div>
        <div v-if="myRoomIdAlias" class="players">Room Id: {{myRoomIdAlias}} </div>
        <div class="players">Players: ({{playersCount}}/5) </div>
    </div>
</template>
<script>
import store from "@/store";
export default {
    computed:{
        roomName:()=>store.state.room.name,
        myRoomIdAlias:()=>store.state.room.myRoomIdAlias,
        playersCount: () => store.getters.playersCount
    }
}
</script>